import React from 'react'
import NavLink from '../common/NavLink'
import { connect } from 'react-redux'
import ProductsItems from '../common/SidebarMenu/ProductsItems'
import EventsItems from '../common/SidebarMenu/EventsItems'
import { FETCH_USER_PROFILE } from '../../actions/actions'
import { toPersianDigit } from '../../helpers/nums'

const styles = {
  badge: { fontSize: 14, color: 'red', margin: 0 },
}

class SchoolMenuItems extends React.Component {
  componentWillMount() {
    if (this.props.schoolProfile) return

    this.props.dispatch({
      type: FETCH_USER_PROFILE,
      userId: this.props.schoolId,
      userType: 'SCHOOL',
    })
  }

  render() {
    const { schoolProfile = {} } = this.props
    const disabled = schoolProfile.verified === false
    const pendingOrders = schoolProfile.pending_orders
    const shouldShowBadge = Boolean(pendingOrders && pendingOrders > 0)
    const isSideBarOpen = this.props.isSideBarOpen

    return (
      <div className="vertical-menu">
        <ProductsItems isSidebarOpen={isSideBarOpen} />
        <EventsItems isSidebarOpen={isSideBarOpen} userType='SCHOOL' />

        {/* <NavLink disabled={disabled} to="/dashboard">
          <i className="fa fa-th-large" aria-hidden="true" />
          <span>داشبورد</span>
        </NavLink> */}

        {/* <NavLink disabled={disabled} to={`/dashboard/school-students/${schoolId}`}>
          <i className="fa fa-user-o" aria-hidden="true" />
          <span>مدیریت دانش آموزان</span>
        </NavLink> */}

        {/* <NavLink disabled={disabled} to="/dashboard/products">
          <i className="fa fa-book" aria-hidden="true" />
          <span>محصولات</span>
        </NavLink> */}

        {/* <NavLink disabled={disabled} to="/dashboard/online-tests">
          <i className="fa fa-pencil-square-o" aria-hidden="true" />
          <span>آزمون آنلاین</span>
        </NavLink> */}

        {/* <NavLink disabled={disabled} to="/dashboard/events">
          <i className="fa fa-calendar" aria-hidden="true" />
          <span>رویداد‌ها</span>
        </NavLink> */}

        {/* <NavLink disabled={disabled} to="/dashboard/certificates">
          <i className="fa fa-certificate" aria-hidden="true" />
          <span>گواهی‌ها</span>
        </NavLink> */}

        {/* <NavLink disabled={disabled} to="/dashboard/apps">
          <i className="fa fa-laptop" aria-hidden="true" />
          <span>نرم افزار‌ها</span>
        </NavLink> */}

        <NavLink disabled={disabled} to="/v/list/?type=package" isExternal={true}>
          <i className="fa fa-gift" aria-hidden="true" />
          <span>بسته‌های تخفیفی</span>
        </NavLink>

        <NavLink disabled={disabled} to="/dashboard/credit">
          <i className="fa fa-credit-card" aria-hidden="true" />
          <span>اعتبار</span>
        </NavLink>

        <NavLink disabled={disabled} to="/dashboard/orders">
          <i className="fa fa-shopping-cart" aria-hidden="true" />
          <span>سفارش‌ها</span>
          <span style={styles.badge}>
            {shouldShowBadge && ` (${toPersianDigit(pendingOrders)}) `}
          </span>
        </NavLink>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    ...state.routing.locationBeforeTransitions,
    schoolId: state.auth.userId,
    schoolProfile: state.profile.userInfo,
    isSideBarOpen: state.sidebar.isOpen,
  }
}

export default connect(mapStateToProps)(SchoolMenuItems)



// WEBPACK FOOTER //
// ./src/components/school/SchoolMenuItems.js